// extracted by mini-css-extract-plugin
export default {"root":"root--eNdBf","title":"title--oHDYB","divider":"divider--t9yQn","dividerIsDark":"dividerIsDark--pf_Mz","btnWrap":"btnWrap--OSbls","body":"body--_XNzp"};